module.exports = __webpack_public_path__ + "static/media/gian-lucca-jorri.b61e1885.png";